var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('span',{staticClass:"status-header"},[_vm._v(_vm._s(_vm.header))]),(_vm.health)?_c('b-tag',{staticClass:"is-success"},[_vm._v("OK")]):_c('b-tag',{staticClass:"is-danger"},[_vm._v("DOWN")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }